import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { BusyService } from '../services/busy.service';

/**
 * Counts in-flight HTTP requests (GraphQL included) for BusyService. Registered in e2e builds only (main.ts), first,
 * so it wraps the other interceptors and a request counts until all of them are done (also on error / cancel).
 */
@Injectable()
export class BusyInterceptor implements HttpInterceptor {
    private readonly busy = inject(BusyService);

    intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return new Observable<HttpEvent<unknown>>(subscriber => {
            this.busy.requestStarted();
            const subscription = next.handle(req).pipe(finalize(() => this.busy.requestFinished())).subscribe(subscriber);
            return () => subscription.unsubscribe();
        });
    }
}
